import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './problemsolving.json';

const Problemsolving = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Problem-solving frameworks, critical thinking, and solution vocabulary. B2 level English exercises."
            level="B2"
            title="Problem Solving"
            image="/Images/problem-solving.webp"
            seoTitle="Free English Lesson Plans: Problem Solving"
            seoDescription="Problem-solving frameworks, critical thinking, and solution vocabulary. B2 level English exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Problemsolving;


